import React from 'react';
import {Glyphicon} from 'react-bootstrap';
import ConfirmDeleteModal, {CommonConfirmDeleteModalProps, CommonConfirmDeleteModalState} from './ConfirmDeleteModal';
import {setMarkedComments} from '../../../../actions/actions';
import {connect} from 'react-redux';

interface DeleteSingleCommentWithIconTagProps {
    commentId: string;
}

interface DeleteSingleCommentWithIconDispatchProps {
    markComment: (id: string) => void;
}

type DeleteSingleCommentWithIconProps = CommonConfirmDeleteModalProps & DeleteSingleCommentWithIconDispatchProps & DeleteSingleCommentWithIconTagProps;

class DeleteSingleCommentWithIcon extends React.Component<DeleteSingleCommentWithIconProps, CommonConfirmDeleteModalState> {

    constructor(props: DeleteSingleCommentWithIconProps) {
        super(props);
        this.state = {
            visible: false
        };
        this.open = this.open.bind(this);
        this.close = this.close.bind(this);
        this.handleDelete = this.handleDelete.bind(this);
    }

    open() {
        this.setState({...this.state, visible: true});
    }

    close() {
        this.setState({...this.state, visible: false});
    }

    handleDelete() {
        this.props.markComment(this.props.commentId);
        this.open();
    }

    render() {
        return (
            <>
                <Glyphicon glyph="trash" className="clickable"
                           onClick={this.handleDelete}/>
                <ConfirmDeleteModal visible={this.state.visible} close={this.close} {...this.props} />
            </>
        );
    }
}

const mapDispatchToProps: DeleteSingleCommentWithIconDispatchProps = {
    markComment: (id: string) => setMarkedComments([id])
};

export default connect(() => ({}), mapDispatchToProps)(DeleteSingleCommentWithIcon);
